"use client"


import { useSearchParams } from "next/navigation";
import { createContext, useContext, useEffect, useState } from "react";

type TrailerContextType = {
    isPlaying: boolean;
    setIsPlaying: (isPlaying: boolean) => void;
}

const TrailerContext = createContext<TrailerContextType>({
    isPlaying: false,
    setIsPlaying: (isPlaying) => { }
});

//#region [Props]
type TrailerWrapperProps = {
    children: React.ReactNode;
};
//#endregion

//#region [Component]
export default function TrailerWrapper({ children }: TrailerWrapperProps) {
    const [isPlaying, setIsPlaying] = useState(false);
    const params = useSearchParams();
    useEffect(() => {
        if (params?.get("showTrailer") === "true") {
            // eslint-disable-next-line react-hooks/set-state-in-effect -- search params are empty when the page is prerendered; reading them during render would break hydration
            setIsPlaying(true);
        }
    }, [params])
    return <TrailerContext.Provider value={{ isPlaying, setIsPlaying }}>{children}</TrailerContext.Provider>;
}
//#endregion

export function useTrailerContext() {
    return useContext(TrailerContext);
}
